import rootLogger from '@/utils/root-logger';

const logger = rootLogger.create('vuex');

// much copied from vuex/dist/logger.js

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find(list, f) {
  return list.filter(f)[0];
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, (c) => c.original === obj);
  if (hit) {
    return hit.copy;
  }

  const copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  });

  Object.keys(obj).forEach((key) => {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

export function VuexLoggerPlugin() {
  let config = {
    includeStates: false,
    logger
  };

  this.setConfig = (params) => {
    config = { ...config, ...params };
  };

  this.createLogger = (params = {}) => {
    this.setConfig(params);

    return function getPlugin(store) {
      let prevState;
      if (config.includeStates) {
        prevState = deepCopy(store.state);
      }

      store.subscribe((mutation, state) => {
        // put payload props in logged object so they get expanded in log output
        // otherwise they appear as "{{object}}"
        const infoToLog = {type: mutation.type, ...mutation.payload};

        if (!config.includeStates) {
          config.logger.log('mutation', infoToLog);
        } else {
          const nextState = deepCopy(state);
          config.logger.log('mutation', { ...infoToLog, states: {prevState, nextState} });
          prevState = nextState;
        }
      });
    };
  };
}

const vuexLoggerPlugin = new VuexLoggerPlugin();

export default vuexLoggerPlugin;
